import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { useLocation } from 'react-router-dom';
import { isContentPage } from 'helpers/page';

const ContentWrapper = ({ children }) => {
  const location = useLocation();
  return isContentPage(location) ? (
    <Container className="print-page-container" fixed>
      <Grid container spacing={2} data-testid="grid-container" className="print-page-content">
        {children}
      </Grid>
    </Container>
  ) : (
    <>{children}</>
  );
};

export default ContentWrapper;
